<template>
  <div class="approval-my-initiated">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.keyword" :placeholder="$t('crm_approval_my_initiated.biao_ti_fa_song_ren')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table index height="100%" :data="tableList" tableCode="examine_approval_my_initiated" :slots="['workflowName', 'action']" @filter="filterChange" @sort="sortChange">
        <template slot="workflowName" slot-scope="scope">
          <div v-if="scope.row.approvalState == 1">{{ scope.row.workflowName }}</div>
          <div v-else class="cell-link"  @click="onWatch(scope.row)">{{ scope.row.workflowName }}</div>
        </template>
        <template slot="action" slot-scope="scope">
          <span></span>
          <el-button v-if="funcView.my_approval_edit && checkRole(scope.row.approvalState, FUNC_TYPES.EDIT) && checkEdit(scope.row)" type="text" size="mini" @click="onEdit(scope.row)">
            {{ funcView.my_approval_edit }}
          </el-button>
          <el-button v-if="funcView.my_approval_submit && checkRole(scope.row.approvalState, FUNC_TYPES.SUBMIT)" type="text" size="mini" @click="onSubmit(scope.row)">
            {{ funcView.my_approval_submit }}
          </el-button>
          <el-button v-if="funcView.my_approval_edit_again && checkRole(scope.row.approvalState, FUNC_TYPES.EDIT_AGAIN) && checkEdit(scope.row)" type="text" size="mini" @click="onEdit(scope.row)">
            {{ funcView.my_approval_edit_again }}
          </el-button>
          <!-- <approve-auth-btn
            v-if="funcView.my_approval_cancel && checkRole(scope.row.approvalState, FUNC_TYPES.CANCEL)"
            :bizId="scope.row.bizId"
            :type="scope.row.workflowType"
            :text="funcView.my_approval_cancel"
            actionType="WITHDRAW"
            @click="onCancel(scope.row)"
          ></approve-auth-btn> -->
          <el-button v-if="funcView.my_approval_cancel && checkRole(scope.row.approvalState, FUNC_TYPES.CANCEL)" @click="onCancel(scope.row)" type="text" size="mini">
            {{ funcView.my_approval_cancel }}
          </el-button>
          <!-- <approve-auth-btn
            v-if="funcView.my_approval_nullify && checkRole(scope.row.approvalState, FUNC_TYPES.NULLIFY)"
            :bizId="scope.row.bizId"
            :type="scope.row.workflowType"
            :text="funcView.my_approval_nullify"
            actionType="INVALID"
            @click="onNullify(scope.row)"
          ></approve-auth-btn> -->
          <el-button v-if="funcView.my_approval_nullify && isNullify(scope.row)" @click="onNullify(scope.row)" type="text" size="mini">{{ funcView.my_approval_nullify }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 合同变更弹窗 -->
    <approval-dialog v-if="dialogVisible" :model="dialogModel" @success="getTableList()" @close="dialogVisible = false"></approval-dialog>
  </div>
</template>

<script>
/** 我发起的 */
import apis from '@/utils/apis';
import languageInjectMixins from '@/mixins/language_inject_mixins';
import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';
// import approveAuthBtn from './approve_auth_btn';

// 页面不做编辑和再次编辑
// 页面没有草稿状态
const FUNC_TYPES = {
  // 编辑
  EDIT: 'EDIT',
  // 再次编辑
  EDIT_AGAIN: 'EDIT_AGAIN',
  // 提交
  SUBMIT: 'SUBMIT',
  // 作废
  NULLIFY: 'NULLIFY',
  // 撤销
  CANCEL: 'CANCEL',
};

const isDev = false;

export default {
  mixins: [languageInjectMixins],
  components: {
    // approveAuthBtn,
    approvalDialog,
  },
  data() {
    return {
      formSearch: {
        workflowClass: null, // 工作流类别，1-合同，2-财务，3-售后，4-库存
        keyword: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
      },
      changeTypeDic: {},
      dialogModel: {},
      dialogVisible: false,
      tableList: [],
      totalRows: 0,
      // 状态与对应的功能点关系
      funcRelation: [
        // 草稿
        {
          statusVal: 1,
          func: [FUNC_TYPES.NULLIFY, FUNC_TYPES.SUBMIT, FUNC_TYPES.EDIT],
        },
        // 审批中
        {
          statusVal: 6,
          func: [FUNC_TYPES.NULLIFY, FUNC_TYPES.CANCEL],
        },
        // 审批通过
        {
          statusVal: 10,
          func: [FUNC_TYPES.NULLIFY],
        },
        // 审批拒绝
        {
          statusVal: 90,
          func: [FUNC_TYPES.EDIT_AGAIN, FUNC_TYPES.NULLIFY],
        },
        // 已作废
        // {
        //   statusVal: 100,
        //   func: [FUNC_TYPES.EDIT_AGAIN]
        // }
      ],
      FUNC_TYPES,
    };
  },
  props: {
    workflowClass: {
      type: Number,
    },
  },
  methods: {
    checkEdit(row) {
      if (['leasing_contract', 'lease_renewal_contract', 'frame_contract', 'trail_order'].includes(row.workflowType)) {
        return false;
      }
      return true;
    },
    // 是否允许作废
    isNullify(row) {
      if (this.dicMap.crm_contract_approval_state) {
        return `${this.dicMap.crm_contract_approval_state.pass}` === `${row.approvalState}`;
      }
      return false;
    },
    // 查看变更
    onWatch: function (row) {
      // 草稿状态不给查看
      if (row.approvalState === 1) {
        return;
      }
      if (['leasing_contract', 'lease_renewal_contract', 'frame_contract', 'frame_order', 'trail_order', 'lease_sales_order'].includes(row.workflowType)) {
        this.jump('/contractdetail', { contractId: row.bizId, approveType: row.workflowType, parentPath: this.$route.path });
        return;
      }
      // this.dialogModel.type = 'watch';
      // this.dialogModel.changeType = row.workflowType;
      // this.dialogModel.changeId = row.bizId;
      // this.dialogModel.row = row;
      // this.dialogVisible = true;
      this.jump('/examine/approvalDetail', {
        workflowType: row.workflowType,
        bizId: row.bizId,
        showProcess: true,
      });
    },
    onEdit(row) {
      // 协议订单
      if (row.workflowType === 'frame_order') {
        this.jump('/contract/agreementOrder/edit', { contractId: row.bizId, contractClass: row.bizClass || '31' });
        return;
      }
      this.dialogModel.type = 'edit';
      this.dialogModel.changeType = row.workflowType;
      this.dialogModel.changeId = row.bizId;
      this.dialogModel.row = row;
      this.dialogVisible = true;
    },
    onEditAgain() {},
    onSubmit(row) {
      const { workflowType, bizId, applyReason, workflowName } = row;
      this.$showConfirm(this.$t('crm_approval_my_initiated.nqdytjxzdspxxm')).then(() => {
        // device_scrap 设备报废 不是用bizId的 要用原来的workflowName进行提交
        const title = workflowType === 'device_scrap' ? workflowName : [`【${bizId}】`, this.getDicValue('approval_type', workflowType)].join(' ');
        this.$postJSON(
          `${apis.apsApproveApprovalApproveStart}/${workflowType}/${bizId}`,
          {
            title: title,
            applyReason: applyReason,
          },
          true
        ).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.getTableList();
        });
      });
    },
    onNullify(row) {
      this.$showConfirm(this.$t('crm_approval_my_initiated.nqdyzfxzdspxxm')).then(() => {
        const { workflowType, bizId } = row;
        this.$postJSON(`${apis.apsApproveApprovalCancel}/${workflowType}/${bizId}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.getTableList();
        });
      });
    },
    onCancel(row) {
      const { workflowType, bizId } = row;
      this.$showConfirm(this.$t('crm_approval_my_initiated.nqdycxxzdspxxm')).then(() => {
        this.$postJSON(`${apis.apsApproveApprovalApproveRevoke}/${workflowType}/${bizId}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.getTableList();
        });
      });
    },
    /**
     * @description 判断是否有相应权限
     * @param {number} status 状态
     * @param {string} funcType 功能类型
     * @return {boolean} 是否有权限
     */
    checkRole(status, funcType) {
      if (isDev) {
        return true;
      }
      const retItem = this.funcRelation.find(item => item.statusVal === status);
      if (!retItem) {
        return false;
      }
      return retItem.func.includes(funcType);
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.$getJSON(apis.apsApprovePageInitiate, this.formSearch).then((res) => {
        this.tableList = !isDev ? res.data.records : [{}];
        this.totalRows = res.data.total;
      });
    },
  },
  mounted() {
    this.formSearch.workflowClass = this.workflowClass || null;
    this.getTableList();
    this.getDicMap('crm_contract_approval_state');
    // this.getDicValue('approval_type', '');
    this.getDictionary('crm_contract_change_type', (data) => {
      this.changeTypeDic = this.$listTransObject(data.crm_contract_change_type, 'value', 'code');
    });
  },
};
</script>

<style lang="scss">
.approval-my-initiated {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
